import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import ComplaintPopup from "../ComplaintPopup/ComplaintPopup";
import "./DistrictMap.css";
import { getBlockHeatmap } from "../../../../api/collectorApi";
import odishamap from "../../../../assest/bihar-map.png";

const DistrictMap = ({ complaintsData = {}, setComplaintsData = () => {}, addNotification }) => {
  const [selectedBlock, setSelectedBlock] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [blinkingBlocks, setBlinkingBlocks] = useState({});
const { t } = useTranslation();
  const previousDataRef = useRef(complaintsData);
  const apiIntervalRef = useRef(null);

  const imageFiles = {
    kankadahad: "kankadahada.png",
    parajang: "parajang.png",
    kamakshyanagar: "kamakshy.png",
    bhuban: "Bhuban.png",
    gendia: "Gandia.png",
    odapada: "odapada.png",
    hindol: "hindol.png",
    dhenkanalsadar: "dhenknal.png",
  };

  const getImagePath = (key) => `/images/${imageFiles[key]}`;

  const blockData = {
    kankadahad: { name: "Kankadahada", image: getImagePath("kankadahad"), position: { top: "3%", left: "34%", width: "26%", height: "28%", zIndex: 5 } },
    parajang: { name: "Parjang", image: getImagePath("parajang"), position: { top: "7%", left: "8%", width: "26%", height: "30%", zIndex: 4 } },
    kamakshyanagar: { name: "Kamakshyanagar", image: getImagePath("kamakshyanagar"), position: { top: "18%", left: "34%", width: "22%", height: "25%", zIndex: 6 } },
    bhuban: { name: "Bhuban", image: getImagePath("bhuban"), position: { top: "6%", left: "58%", width: "24%", height: "22%", zIndex: 4 } },
    gendia: { name: "Gandia", image: getImagePath("gendia"), position: { top: "22%", left: "66%", width: "28%", height: "30%", zIndex: 3 } },
    odapada: { name: "Odapada", image: getImagePath("odapada"), position: { top: "46%", left: "22%", width: "32%", height: "30%", zIndex: 4 } },
    hindol: { name: "Hindol", image: getImagePath("hindol"), position: { top: "52%", left: "2%", width: "35%", height: "40%", zIndex: 3 } },
    dhenkanalsadar: { name: "Dhenkanal Sadar", image: getImagePath("dhenkanalsadar"), position: { top: "52%", left: "21%", width: "30%", height: "34%", zIndex: 4 } },
  };

  const handleBlockClick = (key) => {
    setSelectedBlock(key);
    setShowPopup(true);
  };

  const handleClosePopup = () => {
    setShowPopup(false);
    setSelectedBlock(null);
  };

  useEffect(() => {
    const fetchHeatmap = async () => {
      try {
        const res = await getBlockHeatmap();
        // console.log("res",res?.data?.data?.blocks);
        
        const blocks = res?.data?.data?.blocks || {};

        const newData = {};
        Object.keys(blockData).forEach((key) => {
          const apiKey = blockData[key].name; // match API name
          const blockInfo = blocks[apiKey] || { count: 0, grievances: [] };
          // console.log(blockInfo);
          
          newData[key] = blockInfo;

          // trigger notification if new grievances
          if ((blockInfo.count || 0) > (previousDataRef.current[key]?.count || 0)) {
            addNotification?.(
  t("heatmap.newComplaint", { block: blockData[key].name })
);
          }
        });

        previousDataRef.current = newData;
        setComplaintsData(newData);
      } catch (error) {
        console.error("Heatmap API error:", error);
      }
    };

    fetchHeatmap(); // initial load

    if (!apiIntervalRef.current) {
      apiIntervalRef.current = setInterval(fetchHeatmap, 60000);
    }

    return () => {
      if (apiIntervalRef.current) {
        clearInterval(apiIntervalRef.current);
        apiIntervalRef.current = null;
      }
    };
  }, [setComplaintsData, addNotification]);

  return (
    <div className="district-map-container">
      <div className="map-header">
     <h2>{t("heatmap.title")}</h2>

      </div>

      <div className="map-wrapper">
        <div className="district-map">
          {/* {Object.entries(blockData).map(([key, blk]) => (
            <BlockImage
              key={key}
              id={key}
              block={{ ...blk, count: complaintsData[key]?.count || 0 }}
              isBlinking={false}
              onClick={() => handleBlockClick(key)}
            />
          ))} */}
      <img
  className="odisha"
  src={odishamap}
  alt={t("heatmap.mapAlt")}
/>
        </div>

      </div>

      {showPopup && selectedBlock && (
  <ComplaintPopup
    block={blockData[selectedBlock]}
    blockKey={selectedBlock}                                   // NEW
    complaints={complaintsData[selectedBlock]?.grievances || []} // NEW (real data)
    onClose={handleClosePopup}
  />
)}
    </div>
  );
};

export default DistrictMap;
